import React from "react"
import FormInvestor from "./Form"

export default function CreateInvestor() {
  return <FormInvestor />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Create.js